import {
  Address,
  AccountOnNetwork,
  DevnetEntrypoint,
  MainnetEntrypoint,
  Transaction,
} from '@multiversx/sdk-core'

export const balanceToEGLD = (balance: string): string => {
  const num = parseFloat(balance) / 1000000000000000000
  const res = Math.floor(num * 100) / 100
  return res.toFixed(2)
}

export const displayAddress = (address: string): string => {
  return address?.substring(0, 8) + ' ... ' + address?.substring(54)
}

const entrypoint =
  process.env.NEXT_PUBLIC_TARGET_ENV === 'production'
    ? new MainnetEntrypoint()
    : new DevnetEntrypoint()

export const fetchAddressBalance = async (address: string): Promise<bigint> => {
  const apiNetworkProvider = entrypoint.createNetworkProvider()
  const account = await apiNetworkProvider.getAccount(new Address(address))
  return account.balance
}

export const sendTransaction = async (signedTransaction: Transaction) => {
  return await entrypoint.sendTransaction(signedTransaction)
}

export const getAddressAccount = async (
  address: Address,
): Promise<AccountOnNetwork> => {
  const apiNetworkProvider = entrypoint.createNetworkProvider()
  return await apiNetworkProvider.getAccount(address)
}

export const getAddressNonce = async (address: Address): Promise<bigint> => {
  const account = await getAddressAccount(address)
  return account.nonce
}
